<!--<div class="left-bar-login">-->
<!--</div>-->
<div class="full-page-login">
  <form class="form" [formGroup]="form">
    <div class="item logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="item email" [class.error]="emailCtrl.touched && emailCtrl.errors">
      <label for="email" class="label">Восстановление пароля</label>
      <input class="input" type="text" id="email" placeholder="введите адрес эл. почты" [formControl]="emailCtrl">
    </div>
    <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>
    <div class="btn-wrapper">
      <button class="button" (click)="onSubmit()" [disabled]="isSubmitting">Продолжить</button>
    </div>
  </form>
</div>
